import ReactDOM from "react-dom";
import React from "react";
import AlertRow from "./components/alertRow";
import YoutubeCarousel from "./components/youtubeCarousel";
import YoutubeVideo from "./components/youtubeVideo";
import YoutubeList from "./components/youtubeList";


// Container of the alert row
const alertRowContainer = document.querySelector("#alert-row-container");
if (alertRowContainer != null) {
    ReactDOM.render(<AlertRow />, alertRowContainer);
}

// Video integration
declare const videoList: Array<YoutubeVideo>;

// Video carousel
const videoCarousel = document.querySelector("#video-carousel");
if(videoCarousel != null && videoList.length > 0) {
    ReactDOM.render(<YoutubeCarousel videos={videoList}/>, videoCarousel);
}

// Video display list
const videoDisplayList = document.querySelector("#video-list");
if(videoDisplayList != null && videoList.length > 0) {
    ReactDOM.render(<YoutubeList videos={videoList}/>, videoDisplayList);
}